import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import Backdrop from "../Backdrop/index";
import { useFetchData } from "../../hooks/useFetchData";
import { BiCartAdd, BiDollar } from "react-icons/bi";
import { GiLoveLetter, GiPresent } from "react-icons/gi";
import { MdReviews } from "react-icons/md";
import { GrGroup, GrNotification } from "react-icons/gr";
import { ImCancelCircle } from "react-icons/im";
import { formatArabicDate } from "../../utils/dateformat";
import axios from "axios";
import { BsEye } from "react-icons/bs";

// Array of possible icons
const icons = [BiCartAdd, BiDollar, GiPresent, MdReviews, GrGroup, ImCancelCircle, GiLoveLetter];

// Define the corresponding background and text colors
const iconStyles = {
  BiCartAdd: { bg: "--light-primary", color: "--primary" },
  BiDollar: { bg: "--purple-light", color: "--purple" },
  GiPresent: { bg: "--cyan-light", color: "--cyan" },
  MdReviews: { bg: "--pink-light", color: "--pink" },
  GrGroup: { bg: "--pending-light", color: "--pending" },
  ImCancelCircle: { bg: "--canceled-light", color: "--canceled" },
  GiLoveLetter: { bg: "--cyan-light", color: "--cyan" }
};

const dropIn = {
  hidden: { y: "-100vh", opacity: 0 },
  visible: { y: "0", opacity: 1, transition: { duration: 0.1, type: "spring", damping: 25, stiffness: 500 } },
  exit: { y: "100vh", opacity: 0 },
};

function NotificationsModal({ handleClose }) {
  const [suc, setsuc] = useState("");
  const { data } = useFetchData("mandoub/notification",[suc]);

  const [unseens, setunseens] = useState([]);

  useEffect(() => {
    if(data?.notifications) {
      setunseens(data?.notifications.filter((item) => !item.isSeen))
    }
  
    
  }, [data])

  const handleMarkAsSeen = async () => {
    try {
      await axios.put(
        `${process.env.REACT_APP_API_URL}mandoub/notification`,
        { isSeen: true },
        {
          withCredentials: true,
          headers: {
            Authorization: `Bearer ${JSON.parse(localStorage.getItem('authMandoub'))?.token}`,
          },
        }      );
      setsuc(true)
      handleClose();


    } catch (error) {
      console.error("Error marking notifications as seen:", error);
    }
  };

  const handleNotificationClick = () => {
    if (unseens.length > 0) {
      handleMarkAsSeen();
    }
  };
  

  return (
    <Backdrop onClick={handleClose} isNotification={true}>
      <motion.div
        onClick={(e) => e.stopPropagation()}
        className="modal !py-1 g0 notifications-modal"
        variants={dropIn}
        initial="hidden"
        animate="visible"
        exit="exit"
      >
        <div className="df jc-sb w-full notif-panel">
          <div className="bold-1">الإشعارات</div>
          <div className="df">
            <div className="new" ><span>{unseens?.length} جديدة</span></div>
            <GiLoveLetter />
            <div className="df cursor-pointer" onClick={handleNotificationClick}>تمت المشاهدة <BsEye /></div>
          </div>
        </div>
        <div className="notification-body df-c g0">
          {data && data.notifications.map((notif) => {
            // Select a random icon from the icons array
            const RandomIcon = icons[Math.floor(Math.random() * icons.length)];
            const iconName = RandomIcon.name;
            return (
              <div key={notif._id} className={`notification ${notif.isSeen === false? 'seenn' : ''} w-full df ai-fs`}>
                <div
                  className="rounded-icon"
                  style={{
                    backgroundColor: `var(${iconStyles[iconName]?.bg || '--default-light'})`, // Fallback to a default style
                    color: `var(${iconStyles[iconName]?.color || '--default'})` // Fallback to a default color
                  }}
                >
                  <GrNotification /> {/* Render the randomly selected icon */}
                </div>
                <div className="df-c w-full g0">
                  <div className="text"  style={{"fontSize":"14px"}}>{notif.content}</div>
                  <div className="text mt-4 w-fit mr-auto">{formatArabicDate(notif.createdAt)}</div>
                </div>
              </div>
            );
          })}
        </div>
      </motion.div>
    </Backdrop>
  );
}

export default NotificationsModal;
